import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import SpeakerButton from '@material-ui/icons/VolumeUp';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import Button from '@material-ui/core/Button';
import { img, staticsUrl } from '../../config';

const useStyles = makeStyles(theme => ({
  intro: {
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    background: '#f5f5f5',
    boxSizing: 'border-box',
    '& > h3': {
      color: '#a1008f',
      marginBottom: 20,
      textAlign: 'center',
    }
  },
  introCard: {
    display: 'flex',
    width: 600,
    maxWidth: '100%',
  },
  introDetails: {
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
  },
  introContent: {
    flex: '1 0 auto',
  },
  introCover: {
    width: '40%',
    minHeight: 300,
  },
  introControls: {
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textAlign: 'right',
    '& button': {
      marginRight: 8,
    }
  },
  dialogue: {
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    '& > h3': {
      color: '#a1008f',
      marginBottom: 20,
      textAlign: 'center',
    },
  },
  dialogueInner: {
    background: '#fff',
    padding: 20,
    width: 500,
    maxWidth: '100%',
    overflowY: 'auto',
  },
  question: {
    display: 'flex',
  },
  answer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginTop: 10,
  },
  q: {
    background: '#eee',
    padding: '10px 15px 10px 56px',
    borderRadius: 7,
    position: 'relative',
    minHeight: 50,
    marginLeft: 15,
  },
  a: {
    background: '#eee',
    padding: '10px 56px 10px 15px',
    borderRadius: 7,
    position: 'relative',
    minHeight: 50,
    marginRight: 15,
  },
  arrowLeft: {
    left: -24,
    width: 0,
    bottom: 10,
    height: 0,
    position: 'absolute',
    borderTop: '11px solid transparent',
    borderRight: '25px solid #eeeeee',
    borderBottom: '6px solid transparent',
  },
  arrowRight: {
    right: -24,
    width: 0,
    top: 17,
    height: 0,
    position: 'absolute',
    borderTop: '11px solid transparent',
    borderLeft: '25px solid #eeeeee',
    borderBottom: '9px solid transparent',
  },
  qIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  aIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  img: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    width: '35%',
    paddingBottom: '35%',
  },
  text: {
    width: '65%',
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
    '& > div': {
      margin: '0 15px',
    },
  },
  '@media(max-width: 850px)': {
    introCover: {
      minHeight: 200,
    },
    dialogue: {
      padding: 5,
    },
    dialogueInner: {
      padding: 5,
    },
  },
}));

function Dialogues(props) {
  const classes = useStyles();
  const [ state, setState ] = useState('intro');
  const [ showAnswer, setShowAnswer ] = useState(false);
  const [ showTranslation, setShowTranslation ] = useState(false);
  const [ no, setNo ] = useState(0);
  const { exercise, startStats, finishExercise, action, type } = props.exerciseProps;
  const { question, answer } = exercise.elements[no];
  const len = exercise.elements.length;

  useEffect(() => {
    startStats(type);
    const { pause } = props.media.events;
    const pauseSubscribtion = pause.subscribe((ev) => {
      setShowAnswer(true);
    });
    return () => {
      pauseSubscribtion.unsubscribe();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    state === 'dialogue' && question && question.soundUrl && play(question.soundUrl)
    // eslint-disable-next-line
  }, [no]);


  const play = (url) => {
    action();
    props.media.play(staticsUrl + url);
  }

  const startDialogue = () => {
    setState('dialogue');
    setShowAnswer(false);
    setShowTranslation(false);
    setNo(0);
    question && question.soundUrl && play(question.soundUrl);
  }

  const drawIntro = () => {
    return (
      <div className={classes.intro}>
        <h3>Odpowiedz po angielsku na zadawane pytania</h3>
        <Card className={classes.introCard}>
          <CardMedia
            className={classes.introCover}
            image={staticsUrl + exercise.imageUrl}
            title={exercise.text}
          />
        <div className={classes.introDetails}>
          <CardContent className={classes.introContent}>
            <Typography component="h5" variant="h5">
              {exercise.text}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {exercise.translation}
            </Typography>
          </CardContent>
          <div className={classes.introControls}>
            <Button variant="outlined" color="secondary" onClick={startDialogue} >Start</Button>
          </div>
        </div>
      </Card>
    </div>
    );
  }

  const drawDialogue = () => {
    const onShowAnswer = () => {
      play(answer.soundUrl);
      if (!showTranslation) setShowTranslation(true);
    }
    const next = () => {
      if (no < len - 1) {
        setNo(no + 1);
        setShowTranslation(false);
        setShowAnswer(false);
        if (no === len - 2) finishExercise();
      }
    }
    const prev = () => {
      if (no > 0) {
        setNo(no - 1);
        setShowTranslation(false);
        setShowAnswer(false);
      }
    }

    return (
      <div className={classes.dialogue}>
        <div className={classes.dialogueInner}>

          {Boolean(question) && <div className={classes.question}>
            <div className={classes.img} style={{backgroundImage: `url("${staticsUrl + exercise.imageUrl}")`}}></div>
            <div className={classes.text}>
              <div className={classes.q}>
                <div className={classes.arrowLeft}></div>
                <IconButton className={classes.qIcon} onClick={() => play(question.soundUrl)}>
                  <SpeakerButton />
                </IconButton>
                <span>{question.text}</span>
              </div>
            </div>
          </div>}

          {Boolean(answer) && <div className={classes.answer}>
            <div className={classes.img} style={{backgroundImage: `url("${img('avatar01.png')}")`}}></div>
            <div className={classes.text}>
              {(showAnswer  || !question) && <div className={classes.a}>
                <div className={classes.arrowRight}></div>
                <IconButton className={classes.aIcon} onClick={onShowAnswer}>
                  <SpeakerButton />
                </IconButton>
                <span>{answer.translation}</span>
                {showTranslation && <div style={{color: '#3f51b5'}}>
                  <hr />
                  <span>{answer.text}</span>
                </div>}
              </div>}
            </div>
          </div>}
          <div className={classes.action}>
            <Button variant="outlined" color="secondary" onClick={prev} disabled={no === 0}><PrevIcon /></Button>
              <div>{no + 1}/{len} </div>
            <Button variant="outlined" color="secondary" onClick={next} disabled={no === len - 1 || Boolean(!showTranslation && question)}><NextIcon /></Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {state === 'intro' && drawIntro()}
      {state === 'dialogue' && drawDialogue()}
    </>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(Dialogues);
